import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { LayoutAccountContainerComponent } from './components/layout-account-container/layout-account-container.component';
import { LayoutAccountFooterComponent } from './components/layout-account-footer/layout-account-footer.component';
import { LayoutAccountHeaderComponent } from './components/layout-account-header/layout-account-header.component';
import { LayoutAuthContainerComponent } from './components/layout-auth-container/layout-auth-container.component';
import { LayoutAuthHeaderComponent } from './components/layout-auth-header/layout-auth-header.component';
import { LayoutAccountComponent } from './containers/layout-account.component';
import { LayoutAuthComponent } from './containers/layout-auth.component';
import { LayoutAccountSidebarComponent } from './components/layout-account-sidebar/layout-account-sidebar.component';
import { LayoutModule as KendoLayoutModule } from '@progress/kendo-angular-layout';

@NgModule({
  imports: [
    CommonModule,
    KendoLayoutModule
  ],
  declarations: [
    LayoutAuthComponent,
    LayoutAccountComponent,
    LayoutAccountContainerComponent,
    LayoutAuthContainerComponent,
    LayoutAccountHeaderComponent,
    LayoutAuthHeaderComponent,
    LayoutAccountFooterComponent,
    LayoutAccountSidebarComponent,
  ],
  exports: [
    LayoutAuthComponent,
    LayoutAccountComponent,
    LayoutAccountContainerComponent,
    LayoutAuthContainerComponent,
    LayoutAccountHeaderComponent,
    LayoutAuthHeaderComponent,
    LayoutAccountFooterComponent,
  ]
})
export class LayoutModule {
}



// WEBPACK FOOTER //
// /home/epoirier/PhpstormProjects/spaq-mobile/src/app/layout/layout.module.ts